import React from 'react';
import { Wifi, Thermometer, Flame, Car, Tv, Mountain, Users, Bath } from 'lucide-react';
import { apartmentInfo, apartmentImages } from '../data/mock';

const iconMap = {
  Wifi: Wifi,
  Thermometer: Thermometer,
  Flame: Flame,
  Car: Car,
  Tv: Tv,
  Mountain: Mountain,
};

const About = () => {
  const features = [
    { icon: Wifi, label: 'Besplatan WiFi' },
    { icon: Thermometer, label: 'Klima uređaj' },
    { icon: Flame, label: 'Kamin' },
    { icon: Car, label: 'Privatni parking' },
    { icon: Tv, label: 'TV ravnog ekrana' },
    { icon: Mountain, label: 'Pogled na planine' },
    { icon: Bath, label: 'Moderno kupatilo' },
    { icon: Users, label: '2 + 1 osoba' },
  ];

  return (
    <section id="o-apartmanu" className="py-20 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        {/* Header */}
        <div className="text-center mb-16">
          <p className="text-sage-600 text-sm font-medium tracking-wider mb-2">O apartmanu</p>
          <h2 className="text-3xl md:text-4xl font-serif font-bold text-gray-900">
            Sve što trebate za savršen odmor
          </h2>
        </div>

        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Image */}
          <div className="relative">
            <div className="aspect-[4/3] rounded-2xl overflow-hidden shadow-2xl">
              <img
                src={apartmentImages[3].src}
                alt="Dnevni boravak"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 w-48 h-48 rounded-xl overflow-hidden shadow-xl hidden md:block">
              <img
                src={apartmentImages[0].src}
                alt="Spavaća soba"
                className="w-full h-full object-cover"
              />
            </div>
          </div>

          {/* Content */}
          <div>
            <p className="text-gray-600 text-lg leading-relaxed mb-8">
              {apartmentInfo.description}
            </p>

            {/* Features Grid */}
            <div className="grid grid-cols-3 gap-4">
              {features.map((feature, index) => (
                <div
                  key={index}
                  className="flex flex-col items-center p-4 bg-stone-50 rounded-xl hover:bg-sage-50 transition-colors duration-300 group"
                >
                  <feature.icon
                    size={28}
                    className="text-sage-600 mb-2 group-hover:scale-110 transition-transform duration-300"
                  />
                  <span className="text-xs text-gray-600 text-center">{feature.label}</span>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;